import { useCallback, useEffect, useMemo, useState } from 'react';
import { sortRows } from '../utils/tableSort';

/**
 * Client-side table sorting. Default: id ascending.
 * @param {Array} items
 * @param {{ columns: object, defaultSortKey?: string, defaultSortDir?: 'asc'|'desc', resetKey?: unknown }} options
 */
export default function useTableSort(items, {
    columns,
    defaultSortKey = 'id',
    defaultSortDir = 'asc',
    resetKey = null,
} = {}) {
    const [sortKey, setSortKey] = useState(defaultSortKey);
    const [sortDir, setSortDir] = useState(defaultSortDir);

    useEffect(() => {
        setSortKey(defaultSortKey);
        setSortDir(defaultSortDir);
    }, [resetKey, defaultSortKey, defaultSortDir]);

    const toggleSort = useCallback((key) => {
        if (sortKey === key) {
            setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
        } else {
            setSortKey(key);
            setSortDir('asc');
        }
    }, [sortKey]);

    const sortedItems = useMemo(
        () => sortRows(items, columns, sortKey, sortDir),
        [items, columns, sortKey, sortDir]
    );

    return { sortKey, sortDir, toggleSort, sortedItems, setSortKey, setSortDir };
}
